import { Error, MainArea, TopArea, Page } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import React from 'react';
import { buildNewSftpUserPath } from '../sections/new-sftp-user/utils/helpers';
import { useTranslation } from 'react-i18next';
import { usePermissions, useAccessLevel } from 'core/app/AppContext';
import { NotAuthorisedPage } from 'core/ui/components/error';
import SftpUserTable from './SftpUserTable/SftpUserTable';
import { useQuery } from 'react-query';
import { ISftpUserTableData } from '../entities';
import * as RestApi from 'core/network/RestApi';
import { useHistory } from 'react-router-dom';
import Spinner from '../../../core/ui/components/spinner';

// eslint-disable-next-line no-empty-pattern
export const SftpUserManagementPage: React.FC = (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation();
  const { hasPermission } = usePermissions();
  const { accessLevel } = useAccessLevel();
  const handleNewSftpUserClick = () => {
    history.push(buildNewSftpUserPath());
  };

  const sftpFetchUserQuery = useQuery(['get-sftp-users'], async () => {
    const result = await RestApi.get<ISftpUserTableData[]>(`/public_sftp_users`);
    return result.data;
  });

  const tableData: ISftpUserTableData[] = sftpFetchUserQuery?.data ?? [];

  const hasManageUsersPermission = hasPermission('ManageSftpUsers');

  const notAuthorised = !hasManageUsersPermission || accessLevel !== 'SaleCycle';
  const showError = sftpFetchUserQuery.isError;
  const showSpinner = sftpFetchUserQuery.isLoading;
  const showTable = !showError && !notAuthorised && !showSpinner;

  return (
    <MainArea>
      <TopArea>
        <AppTopBar />
      </TopArea>
      <Page>
        {showError && (
          <div data-testid="SftpUserManagementError">
            <Error
              data-testid="Error"
              heading={t('userManagement.error.heading')}
              description={t('userManagement.error.description')}
            />
          </div>
        )}
        {!showError && notAuthorised && <NotAuthorisedPage />}

        {showSpinner && <Spinner />}

        {showTable && <SftpUserTable tableData={tableData} handleNewSftpUserClick={handleNewSftpUserClick} />}
      </Page>
    </MainArea>
  );
};
export default SftpUserManagementPage;
